import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import Background from '../../assets/images/bg/collection_2026/star_bg_gray.png';
import Logo from '../../assets/images/logo/starcard_club_white.png';

const AdminLayout = () => {
  return (
    <Box
      sx={{
        width: '100%',
        minHeight: '100vh',
        position: 'relative',
        background: `url(${Background}) center center / cover, #FAFAFA`,
      }}
    >
      <Box
        id="header"
        component={'header'}
        sx={{
          width: '100%',
          height: '60px',
          backgroundColor: '#005972',
          padding: '0 10px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Box component={'img'} src={Logo} alt="Starcard Club Logo" sx={{ height: '60px' }} />
      </Box>

      <Box
        id="main"
        component={'main'}
        sx={{
          overflowX: 'hidden',
          overflowY: 'auto',
          width: '100%',
          height: 'calc(100vh - 60px)',
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};
export default AdminLayout;
